import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand } from '@commander-js/extra-typings';
import { validateBase, validateLabel } from './validations.js';

export const releaseCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('release')
    .description('Release a new version of your application')
    .option(
      '--base-url <url>',
      'The base url for when static files have been uploaded to an external cdn',
      validateBase
    )
    .option(
      '-l, --label <label>',
      'A custom label for this release',
      validateLabel
    )
    .action(async (options, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { ReleaseCommand } = await import(
        '../components/ReleaseCommand/index.js'
      );

      const { baseUrl, label } = options;

      await renderCommand(
        command,
        services,
        cliVersion,
        <ReleaseCommand baseUrl={baseUrl} label={label} />
      );
    });
};
